import { Stack, Typography } from "@material-ui/core";
import { Box } from "@material-ui/system";
import image1 from "src/assets/images/wetez_staking_node.svg";
import image2 from "src/assets/images/wetez_reward_distribution.svg";
import image3 from "src/assets/images/wetez_vote_upgrade.svg";
import image4 from "src/assets/images/wetez_inflation.svg";
import dataAnalysis from "src/assets/images/dataAnalysis.svg";
import wetez_governance from "src/assets/images/wetez_governance.svg";

export const StakingWetezBenefits = () => {
  return (
    <Box
      p="100px 0px 149px"
      display="flex"
      flexDirection="column"
      // alignItems="center"
      position="relative"
    >
      <Box display="flex" alignItems="center" pl="46px">
        <Typography fontSize="30px" variant="bold" color="#FFFFFF">
          Services
        </Typography>
      </Box>
      {/* <Typography color="primary" variant="bold" fontSize="30px">
        What will Wetez bring you
      </Typography> */}

      <Box
        mt="23px"
        sx={{
          display: "grid",
          gridTemplateColumns: "repeat(2, 630px)",
          rowGap: "30px",
          justifyContent: "space-between",
          alignItems: "space-between"
        }}
      >

        <Box
          width="630px"
          padding="27px 40px"
          display="flex"
          alignItems="center"
          bgcolor="#191C24"
        >
          <Box minWidth="107px">
            <img src={image1} width="67px" height="96px" alt="img" />
          </Box>
          <Stack>
            <Typography
              variant="bold"
              fontSize="22px"
              color="white"
              lineHeight="22px"
            >
              Staking node
            </Typography>

            <Typography
              fontSize="18px"
              color="#a4a4a4"
              lineHeight="18px"
              mt="14px"
            > 
              Wetez provides node operation to Exchanges, Token 
            </Typography>

            <Typography
              fontSize="18px"
              color="#a4a4a4"
              lineHeight="18px"
              mt="2px"
            >
              Funds and institutions.
            </Typography>
          </Stack>


        </Box>

        <Box
          width="630px"
          padding="27px 40px"
          display="flex"
          alignItems="center"
          bgcolor="#191C24"
        >
          <Box minWidth="147px" paddingRight="40px" boxSizing="border-box" >
            <img src={image2} width="108px" height="98px" alt="img" />
          </Box>

          <Stack >
            <Typography
              variant="bold"
              fontSize="22px"
              color="white"
              lineHeight="22px"
            >
              API service
            </Typography>

            <Typography
              fontSize="18px"
              color="#a4a4a4"
              lineHeight="18px"
              mt="14px"
            >
              Wetez provides API service and infrastructure to the web3 projects. 
            </Typography>


          </Stack>
        </Box>

        <Box
          width="630px"
          padding="27px 40px"
          display="flex"
          alignItems="center"
          bgcolor="#191C24"
        >
          <Box minWidth="107px">
            <img src={image4} width="89px" height="82px" alt="img" />
          </Box>
          <Stack>
            <Typography
              variant="bold"
              fontSize="22px"
              color="white"
              lineHeight="22px"
            >
              Easy-use tool
            </Typography>

            <Typography
              fontSize="18px"
              color="#a4a4a4"
              lineHeight="18px"
              mt="14px"
            >
              Wetez builds easy-use tools for the community to participate in Web3. 
            </Typography>


          </Stack>
        </Box>

        <Box
          width="630px"
          padding="27px 40px"
          display="flex"
          alignItems="center"
          bgcolor="#191C24"
        >
          <Box textAlign="center" minWidth="147px" paddingRight="40px" boxSizing="border-box">
            <img src={dataAnalysis} width="67px" height="81px" alt="img" />
          </Box>

          <Stack>
            <Typography
              variant="bold"
              fontSize="22px"
              color="white"
              lineHeight="22px"
            >
              Data analysis
            </Typography>

            <Typography
              fontSize="18px"
              color="#a4a4a4"
              lineHeight="18px"
              mt="14px"
            > 
              Wetez provides an analytics dashboard of the blockchain data.
            </Typography>


          </Stack>
        </Box>
        <Box
          width="630px"
          padding="27px 40px"
          display="flex"
          alignItems="center"
          bgcolor="#191C24"
        >
          <Box minWidth="107px">
            <img src={wetez_governance} width="90px" height="86px" alt="img" />
          </Box>

          <Stack>
            <Typography
              variant="bold"
              fontSize="22px"
              color="white"
              lineHeight="22px"
            >
              Governance Participation
            </Typography>

            <Typography
              fontSize="18px"
              color="#a4a4a4"
              lineHeight="18px"
              mt="14px"
            > 
              Wetez plays an active role in governance, voting, making proposals, sharing ideas, etc.
            </Typography>


          </Stack>
        </Box>

      </Box>
    </Box>
  );
};
